import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CacheService } from './cache.service';


@Injectable()
export class CacheInterceptor implements HttpInterceptor {

  constructor(private readonly cacheService: CacheService) { }

  public intercept(
    req: HttpRequest<Record<string, unknown>>,
    next: HttpHandler
  ): Observable<HttpEvent<Record<string, unknown>>> {
    if (req.method !== 'GET') {
      return next.handle(req);
    }

    if (!req.headers.get('cache-response')) {
      if (isDefined(this.cacheService.cacheMap.get(req.urlWithParams))) {
        return next.handle(req)
          .pipe(tap((event) => {
            if (event instanceof HttpResponse) {
              this.cacheService.addToCache(req, event);
            }
          }));
      }
      return next.handle(req);
    }

    const cachedResponse = this.cacheService.getFromCache(req);
    if (isDefined(cachedResponse)) {
      return (cachedResponse instanceof Observable) ? cachedResponse : of(cachedResponse.clone());
    }

    return next.handle(req)
      .pipe(tap((event) => {
        if (event instanceof HttpResponse) {
          this.cacheService.addToCache(req, event);
        }
      }));
  }

}
